import { defineStore } from "pinia";
import { ref, computed } from "vue";
import axios from "@/plugins/axios";
import { showMessage } from "@/utils/notifications";

export const useInvestmentStore = defineStore("investment", () => {
  // State
  const investmentList = ref([]);
  const loadingInvestments = ref(false);

  // Getters
  const getInvestmentList = computed(() => investmentList.value);
  const getLoadingInvestments = computed(() => loadingInvestments.value);

  // Actions
  const setInvestmentList = (data) => {
    investmentList.value = data;
  };

  const addInvestment = (data) => {
    for (var i = 0; i < investmentList.value.length; i++) {
      if (investmentList.value[i].entity_id == data.entity_id) {
        investmentList.value[i] = data;
        return;
      }
    }
    investmentList.value.push(data);
  };

  const deleteInvestment = (payload) => {
    let index = investmentList.value.findIndex((e) => e.entity_id == payload.entity_id);
    if (index > -1) {
      investmentList.value.splice(index, 1);
    }
  };

  // API Actions
  const getInvestments = async () => {
    try {
      const response = await axios.get(`/investment`);
      const resData = response.data;

      if (!resData.success) {
        showMessage({ ...resData, messageType: "error", messageTitle: "Error" });
        return resData;
      }

      setInvestmentList(resData.investments);
      return resData;
    } catch (error) {
      console.error("Error fetching investments:", error);
      return { success: false, message: "Failed to fetch investments" };
    }
  };

  const getInvestmentByEntityID = async (entity_id) => {
    try {
      const response = await axios.get(`/investment/${entity_id}`);
      const resData = response.data;

      if (!resData.success) {
        showMessage({ ...resData, messageType: "error", messageTitle: "Error" });
        return null;
      } else {
        return resData.investment;
      }
    } catch (error) {
      console.error("Error fetching investment by entity ID:", error);
      return null;
    }
  };

  const addInvestmentAction = async (payload) => {
    try {
      const { data } = await axios.post(`/investment`, payload);

      if (!data.success) {
        showMessage({ ...data, messageType: "error", messageTitle: "Error" });
        return data;
      }

      showMessage({ ...data, messageType: "success", messageTitle: "Success" });
      addInvestment(data.investment);
      return true;
    } catch (error) {
      console.error("Error adding investment:", error);
      return { success: false, message: "Failed to add investment" };
    }
  };

  const deleteInvestmentAction = async (payload) => {
    try {
      const { data } = await axios.delete(`/investment`, {
        data: { entity_id: payload.entity_id },
      });

      if (!data.success) {
        showMessage({ ...data, messageType: "error", messageTitle: "Error" });
        return data;
      }

      showMessage({ ...data, messageType: "success", messageTitle: "Success" });
      deleteInvestment(payload);
      return true;
    } catch (error) {
      console.error("Error deleting investment:", error);
      return { success: false, message: "Failed to delete investment" };
    }
  };

  const getInvestmentData = async (payload) => {
    try {
      const response = await axios.get(`/investment/${payload.investment_id}`);
      const resData = response.data;

      if (!resData.success) {
        showMessage({ ...resData, messageType: "error", messageTitle: "Error" });
        return null;
      } else {
        return resData.investment;
      }
    } catch (error) {
      console.error("Error fetching investment data:", error);
      return null;
    }
  };

  return {
    // State
    investmentList,
    loadingInvestments,

    // Getters
    getInvestmentList,
    getLoadingInvestments,

    // Actions
    setInvestmentList,
    addInvestment,
    deleteInvestment,

    // API Actions
    getInvestments,
    getInvestmentByEntityID,
    addInvestmentAction,
    deleteInvestmentAction,
    getInvestmentData,
  };
});
